    <div class="modal-header">
        <div class="title">
            <h2 class="modal-title-prefix"><span translate="POLJAZAVELIKELANCE.SINGULAR"></span></h2>
        </div>
        <span class="close" (click)="Close()"><span class="fa fa-fw fa-times"></span></span>
    </div>
    <div class="modal-body">
        <form [formGroup]="formGroup" class="">
        <div class="row">
            <div class="col-md-6">
                <div class="form-group row">
                <!-- <div class="form-group row" *ngIf="fcd && fcd['BrojNarudzbenice'] && fcd['BrojNarudzbenice'].IsVisible"> -->
                    <div class="col-md-12">
                        <yt-input 
                            [Type]="'text'" 
                            [Label]="'FAKDOKUMENT.BROJNARUDZBENICE.SINGULAR'"
                            formControlName="BrojNarudzbenice" 
                            [MaxLength]="50">
                        </yt-input>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-fw-date-picker-popup 
                        name="txtDatumNarudzbenice"
                        formControlName="DatumNarudzbenice"
                        [Label]="'FAKDOKUMENT.DATUMNARUDZBENICE.SINGULAR'">
                        </yt-fw-date-picker-popup>
                    </div>
                </div>
                </div>
        </div>
            <!-- </div> -->
        

        <div class="row" *ngIf="trebaPrijemnica">
            <div class="col-6">
                <div class="form-group row">
                  <div class="col-md-12">            
                    <yt-input 
                      [Type]="'text'"
                      formControlName="BrojPrijemnice" 
                      [Label]="'FAKDOKUMENT.BROJPRIJEMNICE.SINGULAR'" 
                      [MaxLength]="50">
                    </yt-input>
                  </div>
                </div>
              </div>
        
              <div class="col-6">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-fw-date-picker-popup 
                      name="txtDatumPrijemnice"
                      formControlName="DatumPrijemnice" 
                      [Label]="'FAKDOKUMENT.DATUMPRIJEMNICE.SINGULAR'">
                  </yt-fw-date-picker-popup>
                  </div>
                </div>
              </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-md-12">            
                    <yt-input 
                      [Type]="'text'"
                      formControlName="ReferencaKupcaNaDrugiDokument"  
                      [Label]="'FAKDOKUMENT.REFERENCAKUPCANADRUGIDOKUMENT.SINGULAR'">
                    </yt-input>
                  </div>
                </div>
              </div>
        </div>
        <!-- <div class="row">
            <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-md-12">            
                    <yt-input 
                      [Type]="'text'" 
                      formControlName="InterniBrojZaRutiranje" 
                      [Label]="'FAKDOKUMENT.INTERNIBROJZARUTIRANJE.SINGULAR'">
                    </yt-input>
                  </div>
                </div>
              </div>
        </div> -->
          <!-- Odgovorno lice -->
        <div class="row">
         <div class="col-12">
            <div class="form-group row">
              <div class="col-md-12">
                <yt-dropdown-picklist
                  [ModelName]="'osoba'"
                  [GetName]="'get'"
                  [ModelProperty]="'Prezime,Ime,Jmbg'"
                  [OrderBy]="'Prezime'"
                  [AllowAddNew]="true"
                  formControlName="OdgovornoLiceID"
                  [Label]="'FAKDOKUMENT.ODGOVORNOLICE.SINGULAR'"
                  [Width]="'800px'"
                  [Position]="'left'"
                  [Required]="false"
                >
                </yt-dropdown-picklist>
              </div>
            </div>
          </div>
        </div>
    </form>
    </div>
    <div class="modal-footer">
        <button type="submit" class="btn btn-primary" id="btnSave" (click)="Save()" [disabled]="this.Parameters[6].Value"><span>Sačuvaj</span></button>
        <button type="button" class="btn btn-secondary" id="btnClose" (click)="Close()"><span>Odustani</span></button>
    </div>